let sectors = window.sectors || [],
	sectorsFlat = [];

function parseSector(sector) {
	let parsed = {
		id: sector.id,
		name: sector.name,
	};

	if(sector.children && sector.children.length) {
		parsed.children = sector.children.map(sector => parseSector(sector));
	}

	return parsed;
}

function parseSectorFlat(sector) {
	let parsed = {
		id: sector.id,
		name: sector.name,
	};

	sectorsFlat.push(parsed);

	if(sector.children && sector.children.length) {
		sector.children.forEach(sector => parseSectorFlat(sector));
	}
}

sectors = sectors.map(sector => parseSector(sector));
sectors.forEach(sector => parseSectorFlat(sector));

export { sectorsFlat, sectors as default };
